<script setup lang="ts">
import { Dossier } from '@graphql/types/dossiers';
import SingleRequest from '@components/RequestsTable/SingleRequest.vue';
import DossierRequest from '@components/RequestsTable/DossierRequest.vue';

export interface Props {
  dossier: Dossier;
  index: number;
}

defineProps<Props>();

const isRowActive = ref<boolean>(false);
</script>

<template>
  <div
    class="py-5 grid items-center border-b border-gray-50 cursor-pointer md:hover:bg-blue-50 base:gap-x-2 md:gap-x-6 md:grid-cols-12 transition-colors"
    :class="{'bg-blue-100 w-auto -mx-4 px-4 md:mx-0 md:!px-0': isRowActive, 'w-full': !isRowActive}"
    @click.stop="navigateTo({ path: `mijn-aanvragen/${dossier.id}` });"
  >
    <SingleRequest
      v-if="dossier.properties.length === 1"
      :index="index"
      :dossier="dossier"
      :is-row-active="isRowActive"
      @toggle:is-row-active="isRowActive = !isRowActive"
    />
    <DossierRequest
      v-else
      :index="index"
      :dossier="dossier"
      :is-row-active="isRowActive"
      @toggle:is-row-active="isRowActive = !isRowActive"
    />
  </div>
</template>
